export default "__VITE_ASSET__CzDxqa9A__"